import { MeasureLayout } from '../../motion/features/layout/Measure.js';
import { createMotionProxy } from './motion-proxy.js';

/**
 * @public
 */
var m = createMotionProxy([MeasureLayout]);

export { m };



//////////////////
// WEBPACK FOOTER
// ./node_modules/framer-motion/dist/es/render/dom/motion-minimal.js
// module id = 223
// module chunks = 0